import { gql } from '__generated__'

export const GET_FUNDS_INFO_GQL = gql(/** GraphQL */`
  query GetFundsInfo {
    myEnterprise {
      id
      subscription {
        ... on BillingSubscriptionActive {
          plan {
            name
            product {
              features {
                ... on SubscriptionFeatureSkiptrace {
                  __typename
                  prices {
                    included {
                      limit
                      nextRolloverDate
                      used
                    }
                    price
                    pricingUnit
                    pricingUnitDescription
                  }
                }
              }
            }
          }
          currentPeriod {
            end
          }
        }
      }
      wallet {
        balance {
          available
        }
      }
    }
  }
`)
